import { z } from 'zod';

export const uploadPhotoSchema = z.object({
  uploadedFiles: z
    .array(z.any())
    .max(5, 'You can only upload up to five images'),
});

export const uploadQRCodePhotoSchema = z.object({
  uploadedFilesQR: z
    .array(z.any())
    .max(1, 'You can only upload one QR code photo'),
});
